export default "__VITE_PUBLIC_ASSET__3abd602c__"